/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";

const CountUpEffect = ({ value }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (value !== null) {
      let current = 0;
      const step = Math.max(1, Math.floor(value / 50));
      const interval = setInterval(() => {
        current += step;
        if (current >= value) {
          setCount(value);
          clearInterval(interval);
        } else {
          setCount(current);
        }
      }, 10);
      return () => clearInterval(interval);
    }
  }, [value]);

  return <>{Number(count) || 0}</>;
};

export default CountUpEffect;
